import { useAppSelectorShallow } from 'store/hooks';
import Card from 'components/ui/Card';
import LockedFeaturePreview from 'components/ui/LockedFeaturePreview';
import { Separator } from 'components/ui/Separator';
import EnableDataLogging from './EnableDataLogging';
import LogQuestions from './LogQuestions';
import LogType from './LogType';
import TakeNotes from './TakeNotes';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';
import { activityHasPerChoiceLogging } from 'utils/log-quantity-questions.util';

const LogDataTab: React.FC = () => {
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);
  const hasPerChoiceLogging = activity
    ? activityHasPerChoiceLogging(activity)
    : false;
  const isDataLoggingEnabled = hasPerChoiceLogging
    ? false
    : (activity?.log_quantity ?? false);

  return (
    <div className='w-full flex flex-col ~gap-6/8'>
      <EnableDataLogging />

      {!hasPerChoiceLogging && (
        <LockedFeaturePreview isLocked={!isDataLoggingEnabled} blurIntensity='sm'>
          <Card className='flex flex-col ~gap-4/6'>
            <LogQuestions />
            <Separator />
            <LogType />
          </Card>
        </LockedFeaturePreview>
      )}

      <TakeNotes />
    </div>
  );
};

export default LogDataTab;
